import { Component, OnInit, inject, input, ChangeDetectionStrategy } from '@angular/core';
import { DepartmentService } from '@http/clients/reporting-app/department.service';
import { GenericDropdownMultiselectComponent } from 'ngx-lib';
import { FormEditorBase, createValueAccessorProvider } from '../../base/form-editor-base';

@Component({
    selector: 'app-report-department-form-editor',
    templateUrl: './report-department-form-editor.component.html',
    styleUrls: ['./report-department-form-editor.component.scss'],
    providers: [createValueAccessorProvider(ReportDepartmentFormEditorComponent)],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [GenericDropdownMultiselectComponent]
})
export class ReportDepartmentFormEditorComponent extends FormEditorBase<number[] | null> implements OnInit {
    readonly = input<boolean>(false);
    labelText = input<string>('Department');
    placeholderText = input<string>('Select Department');

    private readonly departmentService = inject(DepartmentService);

    async ngOnInit(): Promise<void> {
        const departments = await this.departmentService.getAll();
        this.items.set(departments);
        this.selectedItems.set(this.mapValueToSelectedItems(this.selectedValue() ?? null));
    }

    protected override async onEntityTextChange(): Promise<void> {
        return;
    }

    protected override mapSelectedItemsToValue(): number[] | null {
        const selected = this.selectedItems() ?? [];
        if (!selected.length) return null;
        return selected.map((item) => Number(item.id));
    }

    protected override mapValueToSelectedItems(value: number[] | null): any[] {
        if (!value?.length) return [];
        const selectedIds = new Set(value.map((id) => Number(id)));
        return (this.items() ?? []).filter((item) => selectedIds.has(Number(item.id)));
    }
}
